const stopStream = (stream) => {
    stream?.getTracks().forEach((track) => track.stop());
};

const isPermissionDenied = (err) => (
    err?.name === 'NotAllowedError'
    || err?.name === 'PermissionDeniedError'
    || err?.message?.toLowerCase().includes('permission')
);

const isDeviceNotFound = (err) => (
    err?.name === 'NotFoundError'
    || err?.name === 'DevicesNotFoundError'
    || err?.message?.toLowerCase().includes('requested device not found')
    || err?.message?.toLowerCase().includes('device not found')
);

/**
 * Pide permisos de media de forma tolerante: si no hay cámara, intenta solo audio.
 * Devuelve qué dispositivos quedaron disponibles sin bloquear el join.
 */
export const requestZoomMediaPermissions = async () => {
    if (!navigator.mediaDevices?.getUserMedia) {
        throw new Error('Tu navegador no soporta cámara ni micrófono');
    }

    try {
        const stream = await navigator.mediaDevices.getUserMedia({
            audio: true,
            video: true,
        });
        stopStream(stream);
        return { audio: true, video: true };
    } catch (err) {
        if (isPermissionDenied(err)) {
            throw new Error('Debes permitir cámara o micrófono en el navegador para unirte');
        }

        if (!isDeviceNotFound(err)) {
            throw err;
        }
    }

    try {
        const stream = await navigator.mediaDevices.getUserMedia({
            audio: true,
            video: false,
        });
        stopStream(stream);
        return { audio: true, video: false, warning: 'no-camera' };
    } catch (err) {
        if (isPermissionDenied(err)) {
            throw new Error('Debes permitir el micrófono en el navegador para unirte');
        }
    }

    try {
        const stream = await navigator.mediaDevices.getUserMedia({
            audio: false,
            video: true,
        });
        stopStream(stream);
        return { audio: false, video: true, warning: 'no-microphone' };
    } catch (err) {
        if (isPermissionDenied(err)) {
            throw new Error('Debes permitir la cámara en el navegador para unirte');
        }
    }

    return { audio: false, video: false, warning: 'no-devices' };
};

export const getMediaPermissionHint = async () => {
    if (!navigator.permissions?.query) return 'prompt';

    try {
        const [camera, microphone] = await Promise.all([
            navigator.permissions.query({ name: 'camera' }),
            navigator.permissions.query({ name: 'microphone' }),
        ]);

        if (camera.state === 'denied' || microphone.state === 'denied') {
            return 'denied';
        }
        if (camera.state === 'granted' || microphone.state === 'granted') {
            return 'granted';
        }
        return 'prompt';
    } catch {
        return 'prompt';
    }
};
